import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';
import Slider from 'react-slick';

import ArrowButton from '../../Atoms/ArrowButton/ArrowButton';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './SliderComponent.scss';
let classNames = require('classnames');

const SliderComponent = ({ settings, arrowColor = "black", rtl, children }) => {
  const intl = useIntl();
  const sliderRef = useRef(null);
  const [next_disable, setNextDisabled] = useState(false);
  const [prev_disable, setPrevDisabled] = useState(false);

  const next = () => {
    sliderRef.current.slickNext();
  };
  const previous = () => {
    sliderRef.current.slickPrev();
  };

  const setArrowDisplay = (currentSlide) => {
    if (children.length === 0) { setPrevDisabled(true); return false; }
    const currentSlide_ceil = Math.ceil(currentSlide);
    if (currentSlide_ceil === 0) {
      setPrevDisabled(true);
    } else {
      setPrevDisabled(false);
    }
    //console.log(sliderRef.current)
    if (currentSlide_ceil >= children.length - 1) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  };

  useEffect(() => {
    setArrowDisplay(0);
  }, []);
  if (settings.arrows) {
    settings.nextArrow = <ArrowButton direction='next' callback={next} text={intl.formatMessage({ id: 'carrousel.next' })} disabled={next_disable} textColor={arrowColor} />;
    settings.prevArrow = <ArrowButton direction='prev' callback={previous} text={intl.formatMessage({ id: 'carrousel.prev' })} disabled={prev_disable} textColor={arrowColor} />;
  }
  settings.afterChange = (currentSlide) => setArrowDisplay(currentSlide);
  return (
    <div className={classNames('slider_container', { 'rtl': rtl }, 'color_' + arrowColor)}>
      <Slider {...settings} ref={sliderRef}>
        {children}
      </Slider>
    </div>
  );
};

export default SliderComponent;
